import { ComponentPropsWithRef } from "react";

/**
 * Basic minus (−) icon rendered as an inline SVG.
 *
 * This is a bare-bones icon — it contains only the minus shape itself, with no
 * additional elements. Its size can be adjusted by overriding
 * the `width` and `height` props (defaults are 12×4).
 *
 */
export const MinusIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    width="12"
    height="4"
    viewBox="0 0 12 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="12" height="3.5" rx="0.4" fill="currentColor" />
  </svg>
);
